import React, { useRef } from "react";
import { RelationTypeItem } from "./RelationTypeItem";
import { getCountryByCode } from "../../../../../utils/Helper";
import { Link } from "react-router-dom";
import { Card } from "../../../../common";
import useScreenSize from "../../../../../Hooks/useScreenSize";
export const BusinessRelation = ({ businessRelation }) => {
  const { isMobile, isTablet, isDesktop } = useScreenSize();
  const containerCarousel = useRef(null);

  const btnPressPrev = () => {
    if (containerCarousel.current) {
      const containerWidth = containerCarousel.current.offsetWidth;
      containerCarousel.current.scrollLeft -= containerWidth;
    }
  };

  const btnPressNext = () => {
    if (containerCarousel.current) {
      const containerWidth = containerCarousel.current.offsetWidth;
      containerCarousel.current.scrollLeft += containerWidth;
    }
  };

  return (
    <Card classes="rounded-xl bg-white p-6 mb-6">
      <div className="text-start text-f18 font-semibold">
        <h3 className="text-secondarytwo ">Business Relation</h3>
      </div>
      <div className="rounded-xl sm:grid grid-cols-3 gap-4 containerCarousel p-2 flex overflow-x-hidden scroll-smooth" ref={containerCarousel}>
        {businessRelation.map((businessRelation) => (
          <RelationTypeItem
            name={businessRelation?.business_relationID?.companyID?.registered_company_name || businessRelation?.business_relationID?.registered_company_name}
            country={businessRelation?.business_relationID?.state + ", " + getCountryByCode(
              businessRelation?.business_relationID?.country
            )}
            companyID={businessRelation?.business_relationID?.companyID?.companyID}
            type={"Relation Type"}
            typeValue={businessRelation?.business_relationID?.relation_type?.replace("_", " ")}
          />
        ))}
      </div>
      {isMobile && <div className="carousel_box relative overflow-hidden p-4">
        <button className="pre-btn rotate-180" onClick={btnPressPrev}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="21"
            viewBox="0 0 20 21"
            fill="none"
          >
            <path
              d="M3.33301 10.5H16.6663M16.6663 10.5L11.6663 5.5M16.6663 10.5L11.6663 15.5"
              stroke="#2C5369"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>
        <button className="next-btn" onClick={btnPressNext}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="21"
            viewBox="0 0 20 21"
            fill="none"
          >
            <path
              d="M3.33301 10.5H16.6663M16.6663 10.5L11.6663 5.5M16.6663 10.5L11.6663 15.5"
              stroke="#2C5369"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>
      </div>}
    </Card>
  );
};
